import React from 'react';
import { ISvgIconProps, SvgIcon } from './svg-icon.component';

export const PlusCircleIcon: React.FC<ISvgIconProps> = (props) => {
    return (
        <SvgIcon size={1} fill={"none"} {...props} viewBox="0 0 20 20" ratio={1}>
            <path
                d="M19 9.99536C19 5.02661 14.9688 0.995361 10 0.995361C5.03125 0.995361 1 5.02661 1 9.99536C1 14.9641 5.03125 18.9954 10 18.9954C14.9688 18.9954 19 14.9641 19 9.99536Z"
                stroke="#22AD5C" strokeWidth="1.5" strokeMiterlimit="10"/>
            <path d="M13.75 9.99634H6.25M10 6.24634V13.7463V6.24634Z" stroke="#22AD5C" strokeWidth="1.5"
                  strokeLinecap="round" strokeLinejoin="round"/>
        </SvgIcon>
    )
}
